import { HelperBadgeProps } from './helper-badge-prop.interface';
import React from 'react';

const HelperBadge: React.FC<HelperBadgeProps> = ({ text, className = '' }) => {
  return (
    <div
      className={`
        inline-flex
        items-center
        justify-center
        bg-indigo-50/80
        backdrop-blur-sm
        border
        border-indigo-100/50
        text-indigo-700
        font-spaceGrotesk
        font-medium
        text-sm
        px-3
        py-1.5
        rounded-2xl
        shadow-sm
        shadow-indigo-100/30
        transition-all
        duration-300
        ease-out
        hover:bg-indigo-100/80
        hover:shadow-md
        hover:shadow-indigo-200/40
        hover:border-indigo-200/60
        hover:scale-105
        hover:-translate-y-0.5
        ${className}
      `}
    >
      {text}
    </div>
  );
};

export default HelperBadge;
